export const GET_OPPORTUNITY_DETAILS = "GET_OPPORTUNITY_DETAILS";
export const GET_OPPORTUNITY_STATUS = "GET_OPPORTUNITY_STATUS";
